<template>
	<div id="unauthenticated">
		<transition name="fade">
			<Loading v-if="isLoading" />
			<div v-else>
				<!-- Show the login splash page -->
				<div class="splash">
					<!-- Splash content such as the introduction, sign in, sign up -->
					<div class="splash__content">
						<h1 class="splash__title">WE'VE MOVED!</h1>

						<p class="splash__text">
							We just opened up wholesale.trovebrands.com where you can get products from all of our brands at once!
							<br /><br />
							Visit our upgraded site at https://wholesale.trovebrands.com or just click the button below!
						</p>

						<!-- The login button -->
						<a href="https://wholesale.trovebrands.com/" data-cy="unauth-login-button" class="splash__button">
							<span>Visit Trove Brands</span>
						</a>
					</div>

					<div class="splash__img-wrapper">
						<transition name="crossfade">
							<img class="splash__img" :src="getImageSrc()" :key="currentImageIndex" />
						</transition>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import Loading from '@/components/shared/Loading/index';

export default {
	data() {
		return {
			imagesArray: ['lifestyle_1.jpg', 'lifestyle_2.jpg', 'lifestyle_3.jpg', 'lifestyle_4.jpg', 'lifestyle_5.jpg'],
			currentImageIndex: 0,
			imageInterval: null
		};
	},
	props: {
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		// Get the correct image path
		getImageSrc() {
			return `/images/${this.imagesArray[this.currentImageIndex]}`;
		}
	},
	computed: {
		isDesktop() {
			return this.windowSize.width >= 768;
		}
	},
	components: {
		Loading
	},
	created() {
		// Loop through and show an new image every desired intervial time
		this.imageInterval = setInterval(() => {
			// Only change image if use is on a desktop view
			if (this.isDesktop) {
				// Loop through the indexes for the imagesArray
				this.currentImageIndex = this.currentImageIndex++ < this.imagesArray.length - 1 ? this.currentImageIndex : 0;
			}
		}, 8000);
	},
	destroyed() {
		// Just clear it
		clearInterval(this.imageInterval);
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/styles/mixins/brand-button.scss';
@import '@/styles/mixins/brand-fonts.scss';
@import '@/styles/mixins/brand-link.scss';

#unauthenticated {
	.splash {
		height: 100vh;
		display: flex;
		overflow: hidden;
		&__content {
			background: $brand-off-white;
			width: 100%;
			text-align: left;
			overflow-y: scroll;
			padding: 44px 36px;
			@include media-breakpoint-up(md) {
				width: 60%;
				padding: 100px 120px;
			}
		}
		&__title {
			margin: 0 0 54px;
			font-family: $brand-font-blacker-heavy;
			font-size: 36px;
			line-height: 48px;
			letter-spacing: 1.75px;
			@include media-breakpoint-up(md) {
				font-size: 58px;
				line-height: 72px;
				letter-spacing: 1.8px;
			}
		}
		&__text {
			@include Brand-P2();
			margin: 0 0 45px;

			&--sm {
				@include Brand-P3();
			}
		}
		&__button {
			@include Brand-Button(primary, default);
			margin: 0 0 70px;
		}
		&__link {
			@include Brand-Link($brand-primary);
		}
		&__img-wrapper {
			display: none;
			@include media-breakpoint-up(md) {
				display: block;
				flex: 1;
				overflow: hidden;
				background-color: $brand-black;
				position: relative;
			}
		}
		&__img {
			height: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			min-width: 100%;
			object-fit: cover;
		}
	}
}
</style>
